export default __webpack_public_path__ + "static/media/warning--divided-highway--g7.0a7f27b4.png";